"use client"

const BillsTableHeader = ({ total_bills, total_amount_paid, total_amount_not_paid, sidebarCollapsed }) => {
  return (
    <div className="card-body border-bottom bg-light py-3">
      <div className="row g-3">
        {/* Total Records */}
        <div className="col-lg-3 col-md-6">
          <div className="d-flex align-items-center">
            <div
              className="flex-shrink-0 me-3"
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#e3f2fd",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i className="fa fa-file-invoice text-primary" style={{ fontSize: "16px" }}></i>
            </div>
            <div>
              <div className="text-muted mb-1" style={{ fontSize: "11px", fontWeight: "500" }}>
                TOTAL BILLS
              </div>
              <div className="fw-bold text-dark" style={{ fontSize: "18px" }}>
                {total_bills?.toLocaleString("en-IN") || 0}
              </div>
            </div>
          </div>
        </div>

        {/* Total Paid Amount */}
        <div className="col-lg-3 col-md-6">
          <div className="d-flex align-items-center">
            <div
              className="flex-shrink-0 me-3"
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#e8f5e8",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i className="fa fa-check-circle text-success" style={{ fontSize: "16px" }}></i>
            </div>
            <div>
              <div className="text-muted mb-1" style={{ fontSize: "11px", fontWeight: "500" }}>
                TOTAL PAID
              </div>
              <div className="fw-bold text-success" style={{ fontSize: "18px" }}>
                ₹{total_amount_paid?.toLocaleString("en-IN") || 0}
              </div>
            </div>
          </div>
        </div>

        {/* Total Unpaid Amount */}
        <div className="col-lg-3 col-md-6">
          <div className="d-flex align-items-center">
            <div
              className="flex-shrink-0 me-3"
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#ffebee",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i className="fa fa-exclamation-circle text-danger" style={{ fontSize: "16px" }}></i>
            </div>
            <div>
              <div className="text-muted mb-1" style={{ fontSize: "11px", fontWeight: "500" }}>
                TOTAL UNPAID
              </div>
              <div className="fw-bold text-danger" style={{ fontSize: "18px" }}>
                ₹{total_amount_not_paid?.toLocaleString("en-IN") || 0}
              </div>
            </div>
          </div>
        </div>

        {/* Collection Rate */}
        <div className="col-lg-3 col-md-6">
          <div className="d-flex align-items-center">
            <div
              className="flex-shrink-0 me-3"
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#fff3e0",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i className="fa fa-chart-pie text-warning" style={{ fontSize: "16px" }}></i>
            </div>
            <div>
              <div className="text-muted mb-1" style={{ fontSize: "11px", fontWeight: "500" }}>
                COLLECTION RATE
              </div>
              <div className="fw-bold text-warning" style={{ fontSize: "18px" }}>
                {total_amount_paid && total_amount_paid + total_amount_not_paid > 0
                  ? Math.round((total_amount_paid / (total_amount_paid + total_amount_not_paid)) * 100)
                  : 0}
                %
              </div>
            </div>
          </div>
        </div>
      </div>

      {sidebarCollapsed && (
        <div className="mt-3">
          <div className="alert alert-info py-2 mb-0" style={{ fontSize: "12px" }}>
            <i className="fa fa-info-circle me-2"></i>
            Sidebar is hidden - Full width view enabled for better data visibility
          </div>
        </div>
      )}
    </div>
  )
}

export default BillsTableHeader
